import { AccountUpdate } from 'modules/API';
import Cookies from 'modules/Cookies';
import { isMl3App } from 'modules/DeviceOptions';

window.checkAccountLang = () => {
  if (!isMl3App || !Gdata.Profile.ori) {
    return;
  }

  const { settings: { locale } = {} } = Gdata.Profile.ori;
  if (locale !== window.hlocale) {
    AccountUpdate({
      session: Cookies.get('session'),
      set: {
        'settings.locale': window.hlocale
      }
    }).catch(() => {});
  }
};
